import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";

type Props = {
  handleViewFullDetailsPage: () => void;
};

export const ViewFullDetailsUI = ({ handleViewFullDetailsPage }: Props) => {
  return (
    <div data-component="ViewFullDetails">
      <SecondaryButton onClick={handleViewFullDetailsPage}>
        View full details
      </SecondaryButton>
    </div>
  );
};
